import * as icc from "iso-country-currency"
import * as cc from 'currency-codes'

type getCurrencyProps = {
    countryCode: string
}

export const getCurrencyByCode = ({countryCode}: getCurrencyProps) => {
    try {
        return {
            code: countryCode,
            name: cc.code(countryCode)?.currency,
            symbol: icc.getParamByParam('currency', countryCode, 'symbol')
        }
    } catch (error) {
        return {}
    }
}